const ITEMS = [
  { text: "Make every moment count", big: true },
  { text: "STRATEGY · CREATIVITY · EXECUTION", big: false },
  { text: "360° Corporate solutions", big: true },
  { text: "IDEAS → IMPACT", big: false },
  { text: "One Energy Club", big: true },
  { text: "BUILT FOR BUSINESS · DESIGNED FOR CONNECTION", big: false },
];

function Sequence() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 ${
              item.big
                ? "font-display text-4xl sm:text-6xl font-bold tracking-tight text-white"
                : "font-mono text-xs sm:text-sm tracking-[0.25em] text-gold-bright"
            }`}
          >
            {item.text}
          </span>
          <span className="h-2 w-2 rounded-full bg-gold-bright shadow-[0_0_14px_rgba(240,180,41,0.9)]" />
        </span>
      ))}
    </div>
  );
}

export default function BrandStrip() {
  return (
    <section aria-label="Brand values marquee" className="relative border-y border-gold/25 bg-royal py-10 sm:py-14 overflow-hidden">
      <div className="flex w-max animate-marquee-slow">
        <Sequence />
        <Sequence />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-royal to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-royal to-transparent" />
    </section>
  );
}
